import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import App from './App';

// This finds the 'root' div in your public/index.html file.
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

// This tells React to render your main App component.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

